export const locale = {
    lang: 'fr',
    data: {
        'NAVBAR': {
            'COTISATION': 'Cotisation',
            'LOGOUT': 'Déconnexion',
            'UPTODATE': 'À jour',
            'NOTUPTODATE': 'N\'est pas à jour',
            'MAIL': 'Nouvel email',
            "OPERATIONCANCELED": "Opération annulée",
            "CLOSE": "Fermer",
            "NEWCOTISATION": "Nouvelle cotisation a payer, Montant",
            "NONOTIFICATIONS": "Pas de notifications",
            "AMOUNT":"Montant",
            "SWITCH_TO_ADMIN": "Basculer en mode admin",
            "SWITCH_TO_USER": "Basculer en mode Membre",
        },
        'CHANGEPASSWORD': {
            'TITLE': 'Modifier le mot de passe',
            'CURRENTPASSWORD': 'Mot de passe actuel',
            'CURRENTPASSWORDPLACEHOLDER': 'Entrez votre mot de passe actuel',
            'CURRENTPASSWORDREQUIRED': 'Le mot de passe actuel est requis',
            'NEWPASSWORD': 'Nouveau mot de passe',
            'NEWPASSWORDPLACEHOLDER': 'Entrez votre nouveau mot de passe',
            'NEWPASSWORDREQUIRED': 'Le nouveau mot de passe est requis',
            'NEWPASSWORDMINLENGTH': 'Le mot de passe doit contenir au moins 6 caractères',
            'CONFIRMPASSWORD': 'Confirmer le mot de passe',
            'CONFIRMPASSWORDPLACEHOLDER': 'Confirmez votre nouveau mot de passe',
            'CONFIRMPASSWORDREQUIRED': 'La confirmation du mot de passe est requise',
            'PASSWORDMISMATCH': 'Les mots de passe ne correspondent pas',
            'SUBMIT': 'Modifier le mot de passe',
            'RESET': 'Réinitialiser',
            'SUCCESS': 'Mot de passe modifié avec succès',
            'ERROR': 'Erreur lors de la modification du mot de passe',
            'INVALIDCURRENTPASSWORD': 'Le mot de passe actuel est incorrect'
        }
    }
};
